import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiCauseSipSelectionComponent } from './multi-cause-sip-selection.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';



@NgModule({
  declarations: [
    MultiCauseSipSelectionComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
  ],
  exports: [MultiCauseSipSelectionComponent],
  bootstrap: [MultiCauseSipSelectionComponent]
})
export class MultiCauseSipSelectionModule {
  getComponent() {
    return MultiCauseSipSelectionComponent;
  }
}
